import styled from 'styled-components'

const ReviewContainer = styled.div`
  box-sizing: inherit;
  display: block;
  counter-reset: footnotes;
  /* margin-bottom: 4rem !important; */
  padding-bottom: 2rem !important;
  .r-billboard {
    display: flex;
    align-items: center;
    margin: 3.375rem 0 0;
    max-width: none;
    padding: 0;
    height: 31.25rem;
    padding-bottom: 40px;
    background-color: #ebeaeb;
    @media screen and (max-width: 767px) and (min-width: 0) {
      display: block;
      height: auto;
      margin: calc(71px) 0 0;
    }
    .r-billboard__content {
      box-sizing: inherit;
      max-width: 1366px;
      margin: 0 auto;
      flex-wrap: wrap;
      display: grid;
      grid-column-gap: 5%;
      align-items: center;
      justify-items: self-end;
      justify-content: center;
      height: inherit;
      grid-template-columns: 40% minmax(0, 31.25rem);
      grid-template-rows: 31.25rem;
      @media screen and (max-width: 767px) and (min-width: 0) {
        justify-content: center;
        display: flex;
        align-items: flex-start;
        margin-top: calc(2rem);
      }
      @media screen and (max-width: 1900px) and (min-width: 768px) {
        box-sizing: inherit;
        max-width: 1366px;
        margin: 0 auto;
        flex-wrap: wrap;
        display: grid;
        grid-column-gap: 5%;
        align-items: center;
        justify-items: self-end;
        justify-content: center;
        height: inherit;
        grid-template-columns: 50% minmax(0, 21.25rem);
        grid-template-rows: 30rem;
      }
      .r-billboard__media {
        box-sizing: inherit;
        justify-content: center;
        display: flex;
        align-items: flex-start;
        height: inherit;
        @media screen and (max-width: 60rem) {
          box-sizing: inherit;
          justify-content: center;
          display: flex;
          align-items: flex-start;
          height: inherit;
        }
        img {
          box-sizing: inherit;
          border: 0;
          margin-left: 0;
          max-width: none;
          width: auto;
          max-height: inherit;
          height: inherit;
          @media screen and (max-width: 60rem) {
            max-width: none;
            width: auto;
            max-height: inherit;
            height: inherit;
          }
        }
      }
      .r-billboard__header {
        margin-right: 0;
        text-align: left;
        width: 100%;
        @media screen and (max-width: 767px) and (min-width: 0) {
          order: -1;
          margin: calc(1.5rem) calc(1.5rem) 0;
        }
        .header__btn {
          margin-top: 20px;
          text-rendering: optimizeLegibility;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          height: 50px;
          vertical-align: middle;
          border-width: 0;
          font-weight: 600;
          text-align: center;
          text-decoration: none;
          -webkit-appearance: none;
          cursor: pointer;
          outline-style: none;
          transition-property: all;
          user-select: none;
          white-space: nowrap;
          border-radius: 4px;
          font-size: 1.1rem;
          line-height: 50px;
          transition-duration: 80ms;
          transition-timing-function: linear;
          box-sizing: border-box;
          min-width: 40px;
          background-color: #2db67d;
          box-shadow: inset 0 0 0 1px #e0e6ed;
          color: #fff;
          padding: 0 30px;
          :hover {
            box-shadow: inset 0 -2px 0 rgba(31, 45, 61, 0.15);
            background-color: #2db67d;
          }
        }
        .r-billboard__kicker {
          text-align: left;
          box-sizing: inherit;
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
          .billboard__kicker__text {
            text-align: left;
            box-sizing: inherit;
            margin-right: 10px;
            display: inline-block;
            white-space: nowrap;
            color: var(--theme-text);
            font-weight: 400;
            line-height: 1.429;
            letter-spacing: 0;
            margin-top: 0;
            margin-bottom: 1rem;
            font-size: 0.875rem;
          }
        }
        h1 {
          text-align: left;
          box-sizing: inherit;
          font-weight: 700;
          line-height: 1.12;
          letter-spacing: -0.8px;
          font-size: 3.125rem;
          color: var(--theme-text);
          margin: 0 auto calc(0.5rem);
        }
        p {
          text-align: left;
          box-sizing: inherit;
          font-family: Slack-Circular-Pro, "Helvetica Neue", Helvetica,
            "Segoe UI", Tahoma, Arial, sans-serif;
          font-weight: 400;
          line-height: 1.44444444;
          letter-spacing: normal;
          font-size: 1.125rem;
          margin: 0;
          color: var(--theme-text);
          margin-bottom: 0;
        }
      }
    }
  }
  .r-post {
    box-sizing: inherit;
    justify-content: center;
    margin: calc(1.5rem) auto 0;
    max-width: 68.75rem;
    display: grid;
    padding: 0;
    grid-column-gap: 7rem;
    grid-template-columns: 24rem 42rem;
    margin-top: calc(10rem);
    img {
      width: 95%;
    }
    @media screen and (max-width: 767px) and (min-width: 0) {
      display: grid;
      grid-column-gap: 10.97560976%;
      grid-template-columns: 100%;
      background: #fff;
    }
    @media screen and (max-width: 60rem) {
      box-sizing: inherit;
      justify-content: center;
      margin: calc(1.5rem) auto 0;
      max-width: 43.75rem;
      display: grid;
      grid-column-gap: 10.97560976%;
      grid-template-columns: 100%;
      padding: 0 4vw;
    }

    .r-article-toc {
      box-sizing: inherit;
      display: block;
      left: 0;
      z-index: 900;
      background-color: #fff;
      margin-bottom: 1rem;
      max-height: 600px;
      width: 340px;
      position: sticky;
      top: 130px;
      right: 0;
      margin-top: 1rem;
      grid-area: aside;
      align-self: flex-start;
      border: 6px solid #DFE1E2;
      padding: 1rem 1rem 2rem 0;
      @media screen and (max-width: 60rem) {
        /* width: 100%;
        padding: 1rem 0rem 2rem 0;
        margin-top: 90px; */
        display: none;
      }
      .product-name {
        padding-left: 19px;
        h2 {
          margin-top: 5px;
          margin-bottom: 5px;
          font-size: 40px;
          letter-spacing: -0.9px;
        }
        p {
          margin-top: 5px;
          margin-bottom: 30px;
          font-weight: 600;
        }
        .article-type {
          color: #A9AEB2;
          margin-top: 20px;
          margin-bottom: 5px;
        }
      }
      .r-article-toc--btn {
        font-weight: 700;
        margin-bottom: 0;
        text-align: left;
        border-radius: 0;
        text-transform: uppercase;
        position: relative;
        border-bottom: 1px solid #ebeaeb;
        padding-bottom: 0.5rem;
        width: auto;
        margin-left: 1rem;
        display: block;
        @media screen and (max-width: 767px) and (min-width: 0) {
          font-size: 22px;
        }
      }
      .r-article-toc--contents {
        box-sizing: inherit;
        max-height: 435px;
        padding-right: 0.5rem;
        margin: 1rem 0;
        transition: 0.3s ease;
        overflow-y: auto;
        border-top: 0;
        display: block;
        ul {
          line-height: 1.44444444;
          letter-spacing: normal;
          font-size: 1.125rem;
          padding: 0;
          list-style: none;
          margin: 0;
          font-weight: 700;
          li {
            list-style: none;
            box-sizing: inherit;
            border-bottom: 0;
            padding-top: 0;
            cursor: pointer;
            font-weight: 700;
            letter-spacing: 0.2px;
            margin-top: 0;
            font-size: 0.875rem;
            margin-bottom: 0.5rem;
            padding-left: 1.25rem;
            padding-bottom: 0;
            line-height: 1.5rem;
            span {
              list-style: none;
              cursor: pointer;
              font-weight: 600;
              letter-spacing: 0.2px;
              font-size: 1rem;
              line-height: 1.4rem;
              box-sizing: inherit;
              display: block;
              position: relative;
              font-size: 18px;
              :hover {
                color: #3370FF;
              }
            }
          }
        }
      }
      .r-article-toc--cta {
        box-sizing: inherit;
        display: block;
        margin-left: 1rem;
      }
      .r-button {
        word-break: break-word;
        -webkit-appearance: none;
        background: 0 0;
        border: none;
        cursor: pointer;
        border-radius: 4px;
        text-align: center;
        font-weight: 700;
        line-height: 1.28571429;
        letter-spacing: 0.8px;
        text-transform: uppercase;
        text-decoration: none;
        padding: 19px 40px 20px;
        transition: box-shadow 420ms cubic-bezier(0.165, 0.84, 0.44, 1),
          color 420ms cubic-bezier(0.165, 0.84, 0.44, 1),
          background 420ms cubic-bezier(0.165, 0.84, 0.44, 1);
        font-size: 1rem;
        white-space: nowrap;
        flex-basis: auto;
        width: auto;
        background-color: #ecb22e;
        color: #1d1d1d;
        fill: #1d1d1d;
        display: block;
        :hover {
          background-color: #269869;
        }
      }
    }
    .r-post-content {
      box-sizing: inherit;
      position: relative;
      padding-bottom: 100px;
      .r-post-container {
        font-size: 1.15rem;
        box-sizing: inherit;
        @media screen and (max-width: 767px) and (min-width: 0) {
          margin-top: 110px;
        }
        .r-post-intro {
          margin-top: 50px;
          font-size: 1.9rem;
          line-height: 1.3;
          text-align: justify;
          width: 100%;
          span {
            
            color: #1F62FF;
            font-weight: 700;
          }
        }
        p {
          @media screen and (max-width: 767px) and (min-width: 0) {
            margin: calc(3.5rem) auto 0 !important;
            max-width: 20rem;
            font-size: 22px !important;
          }
        }
        .score-rating {
          background: #ffd155;
          padding: 5px 10px;
          border-radius: 3px;
        }
        .r-content-list-positives {
          font-weight: 400;
          line-height: 1.3;
          letter-spacing: normal;
          margin-bottom: 1rem;
          font-size: 1rem;
          counter-reset: number;
          list-style: none;
          padding-inline-start: calc(20px + 1rem);
          width: 85%;
          li {
            font-weight: 400;
            line-height: 1.44444444;
            letter-spacing: normal;
            font-size: 1.15rem;
            list-style: none;
            box-sizing: inherit;
            position: relative;
            margin-bottom: 20px;
            @media screen and (max-width: 767px) and (min-width: 0) {
              font-size: 18px;
            }
            ::before {
              display: block;
              position: absolute;
              top: 5px;
              left: calc(-1rem + -20px);
              width: 23px;
              height: 23px;
              text-align: center;
              margin-bottom: 0;
              font-weight: 700;
              letter-spacing: -0.025em;
              line-height: 1.4;
              background-color: #1BB954;
              color: #fff;
              border: 0;
              background-clip: padding-box;
              counter-increment: number;
              content: counter(number);
              border-radius: 100%;
              font-size: 0.9rem;
            }
          }
        }
        .r-content-list-negatives {
          font-weight: 400;
          line-height: 1.3;
          letter-spacing: normal;
          margin-bottom: 1rem;
          font-size: 1rem;
          counter-reset: number;
          list-style: none;
          padding-inline-start: calc(20px + 1rem);
          width: 85%;
          li {
            font-weight: 400;
            line-height: 1.44444444;
            letter-spacing: normal;
            font-size: 1.15rem;
            list-style: none;
            box-sizing: inherit;
            position: relative;
            margin-bottom: 20px;
            @media screen and (max-width: 767px) and (min-width: 0) {
              font-size: 18px;
            }
            ::before {
              display: block;
              position: absolute;
              top: 5px;
              left: calc(-1rem + -20px);
              width: 23px;
              height: 23px;
              text-align: center;
              margin-bottom: 0;
              font-weight: 700;
              letter-spacing: -0.025em;
              line-height: 1.4;
              background-color: #F64740;
              color: #fff;
              border: 0;
              background-clip: padding-box;
              counter-increment: number;
              content: counter(number);
              border-radius: 100%;
              font-size: 0.9rem;
            }
          }
        }
        .r-product-box {
          display: flex;
          flex-flow: wrap;
          border: 6px solid #DFE1E2;
          margin-top: 2.5vh;
          margin-left: -8px;
          position: relative;
          padding: 25px 20px 20px 20px;
          @media screen and (max-width: 767px) and (min-width: 0) {
            margin: 0 !important;
            padding: 10px 0 40px 0;
          }

          .product-box-brand {
            position: absolute;
            top: -20px;
            left: -20px;
            background: #1A1C1D;
            padding: 6px 15px;
            font-size: 21px;
            font-family: "Barlow", sans-serif;
            color: #fff;
            width: auto;
            font-weight: 600;
          }
          .product-left {
            width: 40%;
            padding: 10px;
            @media screen and (max-width: 767px) and (min-width: 0) {
              width: 100%;
            }
            img {
              width: 100%;
            }
          }
          .product-right {
            width: 50%;
            padding: 10px 10px 10px 30px;
            @media screen and (max-width: 767px) and (min-width: 0) {
              width: 100%;
              padding: 0;
            }
            p {
              width: 100%;
            }
            a {
              font-weight: 700;
              color: #1A1C1D;
            }
          }
          .product-btn {
            width: 50%;
          }
          .product-btn a {
            word-break: break-word;
            -webkit-appearance: none;
            background: 0 0;
            border: none;
            cursor: pointer;
            border-radius: 4px;
            text-align: center;
            font-weight: 700;
            line-height: 1.28571429;
            -webkit-letter-spacing: 0.8px;
            -moz-letter-spacing: 0.8px;
            -ms-letter-spacing: 0.8px;
            letter-spacing: 0.8px;
            text-transform: uppercase;
            -webkit-text-decoration: none;
            text-decoration: none;
            padding: 10px 20px 10px;
            -webkit-transition: box-shadow 420ms
                cubic-bezier(0.165, 0.84, 0.44, 1),
              color 420ms cubic-bezier(0.165, 0.84, 0.44, 1),
              background 420ms cubic-bezier(0.165, 0.84, 0.44, 1);
            transition: box-shadow 420ms cubic-bezier(0.165, 0.84, 0.44, 1),
              color 420ms cubic-bezier(0.165, 0.84, 0.44, 1),
              background 420ms cubic-bezier(0.165, 0.84, 0.44, 1);
            font-size: 0.85rem;
            white-space: nowrap;
            -webkit-flex-basis: auto;
            -ms-flex-preferred-size: auto;
            flex-basis: auto;
            width: auto;
            background-color: #ecb22e;
            color: #1d1d1d;
            fill: #1d1d1d;
            display: block;
            :hover {
              background-color: #269869;
            }
          }
        }
        p {
          text-align: justify;
          font-weight: 400;
          line-height: 1.5;
          letter-spacing: normal;
          font-size: 1.1rem;
          margin: 0.9rem 0 2rem 0;
          width: 95%;
          @media screen and (max-width: 767px) and (min-width: 0) {
            margin-bottom: 10px !important;
            margin-top: 30px !important;
            line-height: 1.3;
          }
        }
        h2 {
          font-weight: 700;
          line-height: 1.1875;
          letter-spacing: -0.3px;
          font-size: 2rem;
          margin-bottom: 1rem;
          margin-top: calc(6rem);
          ::before {
            content: "";
            margin-bottom: 1rem;
            width: 65px;
            height: 7px;
            display: block;
            background: #1A1C1D;
          }
        }
      }
    }
    img {
      @media screen and (max-width: 767px) and (min-width: 0) {
        margin-top: 20px;
        width: 100%;
      }
    }
  }
`
export default ReviewContainer;